<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1>New Verification Run</h1>
        <p class="grey--text">
          Pull a stratified sample of post-QC subjects to verify. Subjects are
          pinned to the QC pass that was active at sample creation.
        </p>
      </v-col>
    </v-row>

    <v-form @submit.prevent="submit" ref="form" v-model="formValid">
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            label="Period start"
            v-model="periodStart"
            type="date"
            outlined dense :rules="dateRules" required
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            label="Period end (exclusive)"
            v-model="periodEnd"
            type="date"
            outlined dense :rules="dateRules" required
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-autocomplete
            label="Projects (leave empty for all)"
            v-model="selectedProjectIds"
            :items="projectChoices"
            item-text="name"
            item-value="id"
            multiple chips small-chips outlined dense clearable
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6" md="3">
          <v-text-field
            label="Target per stratum"
            v-model.number="targetPerStratum"
            type="number" min="1" outlined dense required
          />
        </v-col>
        <v-col cols="6" md="3">
          <v-text-field
            label="Floor per stratum"
            v-model.number="floorPerStratum"
            type="number" min="0" outlined dense required
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-btn color="primary" depressed type="submit" :loading="submitting" :disabled="!formValid">
            Create + Sample
          </v-btn>
          <v-btn text class="ml-2" to="/verification">
            Cancel
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'VerificationRunForm',
  data () {
    return {
      periodStart: '',
      periodEnd: '',
      selectedProjectIds: [],
      targetPerStratum: 30,
      floorPerStratum: 5,
      submitting: false,
      formValid: false,
      dateRules: [v => !!v || 'required'],
    }
  },
  computed: {
    ...mapGetters(['getProjects']),
    ...mapState({
      defaultTarget: (s) => s.settings.verificationTargetPerStratum,
      defaultFloor: (s) => s.settings.verificationFloorPerStratum,
    }),
    projectChoices () {
      return this.getProjects.map(p => ({ id: p.id, name: p.name || `Project ${p.id}` }))
    },
  },
  mounted () {
    this.targetPerStratum = this.defaultTarget || 30
    this.floorPerStratum = this.defaultFloor || 5
    // Default window: prior 7 days.
    const now = new Date()
    const start = new Date(now); start.setDate(start.getDate() - 7)
    this.periodEnd = now.toISOString().slice(0, 10)
    this.periodStart = start.toISOString().slice(0, 10)
  },
  methods: {
    ...mapActions(['createSampleRun']),
    async submit () {
      this.submitting = true
      try {
        const run = await this.createSampleRun({
          period_start: new Date(this.periodStart).toISOString(),
          period_end: new Date(this.periodEnd).toISOString(),
          project_ids: this.selectedProjectIds.length ? this.selectedProjectIds : null,
          target_per_stratum: this.targetPerStratum,
          floor_per_stratum: this.floorPerStratum,
        })
        this.$router.push(`/verification/runs/${run.id}`)
      } catch (e) {
        // Error already captured in store; surface a basic alert.
        alert('Failed to create run: ' + (e.response && e.response.data ? JSON.stringify(e.response.data) : e.message))
      } finally {
        this.submitting = false
      }
    },
  },
}
</script>
